export default __webpack_public_path__ + "locales/zh-CN/DowngradePlanDialog.json?hash=1b6ecff8bc5c83e7f7abc88498383772";